import type {
  ScheduleMembershipSchema,
  ShiftRQSchema
} from '@libs/data-access/queries'
import { useCommonAppTranslation } from '@libs/utils/translations'

type Props = {
  membership?: ScheduleMembershipSchema
  shift: ShiftRQSchema
}

const useGetDefaultUserContract = ({
  membership,
  shift
}: Props): { label?: string; value: number; highlight?: string } => {
  const { t } = useCommonAppTranslation()

  return {
    label: t('models.fullname', {
      value: {
        firstname: membership?.firstname,
        lastname: membership?.lastname
      }
    }),
    value: shift.user_contract_id
  }
}

export default useGetDefaultUserContract
